module.exports = __webpack_public_path__ + "static/media/logout-icon.38d5d308.svg";